import React, { useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { matchPath } from "react-router-dom";
import { useAuth } from '../../contexts/AuthContext';
import ErrorBoundary from 'components/ErrorBoundary';
import __ from 'localisation';
import SkipToContentLink from 'components/SkipToContentLink';
import { LoadingBox, LoadingBar } from '@hubins/components/LoadingIndicators';
// import Heading from '@hubins/components/Heading';
import Icon from '@hubins/components/IconNew';
import Main from 'components/Main';
import Wrapper from '@hubins/components/Wrapper';
import Heading from '@hubins/components/Heading';
import PageFooter from 'components/PageFooter';
import SyncUserButton from '@hubins/components/SyncUserButton';
import { ButtonWrap } from '@hubins/components/Button';
import { useMiddleman } from '@hubins/middleman';
import { useHistory } from 'react-router-dom';
import BackofficeSidebar from '@backoffice/components/BackofficeSidebar';
import { isAdmin } from 'helpers/userRoles';
import DeletePortfolioButton from '@hubins/components/DeletePortfolioButton';

import './ClientLayout.scss';
import './LayoutDefault.scss';
import BackofficeProfileLink from '@hubins/components/BackofficeProfileLink';

// IMPORTANT: Route must have a param named "uid"
const ClientLayout = (props) => {
  const { user, userRoles } = useAuth();
  const name = user?.name || '';
  const userUuid = user?.uuid;
  const contact_type = user?.roles?.[0]?.name;
  const middleman = useMiddleman();

  const history = useHistory();
  const match = matchPath(props.location.pathname, props);
  const { profileUuid, portfolioUuid } = match.params;
  const TheComponent = props.component || props.render;

  const [client, setClient] = useState(false);
  const [portfolio, setPortfolio] = useState(false);

  const init = async () => {
    const res = await middleman.get(`/portfolio/${portfolioUuid}`);
    const portfolioRes = res.data;
    if (!profileUuid || profileUuid === 'undefined' || profileUuid === 'null') {
      const policyHolder = portfolioRes.policy_holder[0];
      const url = props.location.pathname.replace('undefined', policyHolder.uuid);
      history.push(url);
      setClient(policyHolder);
    } else {
      const policyHolder = portfolioRes.policy_holder.find((ph) => ph.uuid === profileUuid);
      setClient(policyHolder);
    }
    setPortfolio(portfolioRes);
  };

  useEffect(() => {
    init();
  }, [profileUuid]);

  const ssn = client ? client.national_identity_number : '';

  return (
    <>
      <SkipToContentLink
        target="MainContent"
        text={__('skip_to_main_content')}
      />
      {/* <div className="side-menu-layout" data-shiftonsidebaropen> */}
      <ErrorBoundary>
        <div className="side-menu-layout">
          <BackofficeSidebar
            {...props}
            name={name}
            userRoles={userRoles}
            contact_type={contact_type}
          />
          <div className="layout_default__main">
            <Main noSpace className="relative">
              <Wrapper rounded stretch tight className="backoffice-wrapper">
                <div className="flex flex--row align-items-center space-between">
                  <Heading size="2" className="c-primary s-left-m width-auto">
                    {portfolio ? portfolio.short_name : <LoadingBar large h1 />}
                  </Heading>
                  <div className="clientlayout-sync">
                    <span><strong>{__('latest_update')}</strong>: {portfolio.updated_at}</span>
                    <ButtonWrap>
                      <SyncUserButton portfolioUuid={portfolioUuid} />
                      {isAdmin(userRoles) && (
                        <DeletePortfolioButton portfolioUuid={portfolioUuid} />
                      )}
                    </ButtonWrap>
                  </div>
                </div>
                <div className="flex flex--row align-items-center s-left-m ">

                  <BackofficeProfileLink profileUuid={client?.uuid}>
                    <Icon title="name" icon="user" size={16} className="s-right-s"  />
                    {client ? client.name : ''}
                  </BackofficeProfileLink>
                  {/* <Button external small className="link withicon withicon--left" href={`tel:${phone}`}>
                    <Icon title="phone" icon="phone" size="small" />
                    {phone}
                  </Button> */}
                  <BackofficeProfileLink profileUuid={client?.uuid}>
                    <Icon title="ssn" icon="Touch Id 1" size={16} className="s-right-s s-left-m"/>
                    {ssn}
                  </BackofficeProfileLink>

                  {/* <Button external small className="link withicon withicon--left" href={`mailto:${email}`}>
                    <Icon title="email" icon="mail" size="small" />
                    {email}
                  </Button> */}
                </div>
                <hr />
                {/* <WrapperContent wide> */}
                {(client && portfolio && profileUuid !== 'undefined') ? (
                  <>
                    <Route
                      {...props}
                      component={undefined}
                      render={(renderProps) => {
                        return <TheComponent {...renderProps} client={client} portfolio={portfolio} userUuid={userUuid} />;
                      }}
                    />
                  </>
                ) : (
                  <LoadingBox />
                )}

                {/* </WrapperContent> */}
              </Wrapper>
            </Main>
            <PageFooter />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );

};

export default ClientLayout;
